// This file handles both CPD Search and Insights Search.
// CPD Search was built first, so the 'aps-cpd-search' class is used for both.

import Taggle from 'taggle'

window.addEventListener('DOMContentLoaded', function () {
  const $search = document.querySelector('.aps-cpd-search')

  if ($search) {
    // Insights Search does not use Taggle
    const isInsights = $search.classList.contains('aps-insights-search')

    if (!isInsights) {
      new Taggle('aps-cpd-search__input', {
        placeholder: 'Search for a topic',
        saveOnBlur: true,
      })
    }

    // Dynamic endpoint from Kentico CMS
    const $searchEndpoint = document.querySelector('input[id$=hfResultsPath]')
    const $searchSubmit = document.querySelector('.aps-cpd-search__search-submit')
    let $searchInput = document.querySelector('.aps-cpd-search__input')

    if (isInsights) {
      const $input = document.createElement('input')
      $input.classList.add('aps-cpd-search__input')
      $input.placeholder = 'Search for an article'
      const params = new URLSearchParams(window.location.search)
      const searchStr = params.get('s')
      if (searchStr) $input.value = searchStr
      $searchInput.replaceWith($input)
      $searchInput = $input
    }

    $searchSubmit.addEventListener('click', function (ev) {
      ev.preventDefault()
      let searchStr = ''
      if (isInsights) {
        searchStr = $searchInput.value
      } else {
        const $tags = document.querySelectorAll('.taggle input')
        const tags = Array.from($tags).reduce((acc, curr) => {
          return (acc += curr.value + ',')
        }, '')
        // Remove last comma
        searchStr = tags.slice(0, -1)
      }
      const uri = `${$searchEndpoint.value}${encodeURIComponent(searchStr)}`
      window.location.href = uri
    })

    $searchInput.addEventListener('keydown', function (ev) {
      if (ev.keyCode === 13) {
        ev.preventDefault()
        if (isInsights) {
          $searchSubmit.click()
        } else {
          // If the user presses Enter, just add the tag (via Taggle)
          return false
        }
      }
    })
  }
})
